import homeBackground from "../../../assets/webp/homeBackground.webp";
import { FaArrowRight } from "react-icons/fa";

const TopImageSection = ({ title, text, page ,shedulePickup }) => {
  
  return (
    <div
      className="flex justify-center items-center flex-col text-center text-white h-[230px] "
      style={{
        backgroundImage: `url(${homeBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <h2 className="text-lg xs:text-xl md:text-2xl md:text-[32px] font-extrabold text-[#023B64] mb-3">
        {title}
      </h2>
      <p className="text-[#242B33] font-[500] text-xs md:text-base max-w-3xl mx-auto">
        {text}
      </p>
      {page === "home" && (
        <button
        onClick={() => shedulePickup()}
         className="mt-6 inline-flex items-center gap-3 bg-white text-[#00365A] pl-5 py-2 pr-[6px] border border-[#AEE0F5] rounded-full font-medium shadow-lg text-base md:text-lg  lg:text-xl hover:shadow-xl hover:bg-[#f0f8ff] transition">
          Schedule Your Pickup
          <span className="w-[36px] h-[36px] md:w-[40px] md:h-[40px] flex justify-center items-center bg-gradient-to-br from-[#0FAEEF] to-[#1876A9] text-white rounded-full p-1">
            <FaArrowRight />
          </span>
        </button>
      )}
    </div>
  );
};

export default TopImageSection;
